<template>
  <div v-if="form.sent === true" class="row pb-15">
    <div class="col-16 text-center">
      <h4 class="fw-bold">THANK YOU</h4>
    </div>

    <div class="col-16 text-center">
      <p class="small text-secondary mb-3">{{ form.name }}</p>
      <p class="xxlarge font-weight-bold mb-8">FOR YOUR INQUIRY</p>
      <img :src="image" class="img-fluid img-167 mb-8" alt="Check">
      <p class="small font-weight-black mb-2">Your inquiry has been successfully sent!</p>
      <p class="small">The Athenian House team, will respond to your request soon.</p>
    </div>
  </div>

  <form v-else @submit.prevent="submit()" method="POST">
    <slot :v$="v$" :form="form" :dateChecker="dateChecker" :sunsetDisabled="sunsetDisabled" :aftersunsetDisabled="aftersunsetDisabled" :latenightDisabled="latenightDisabled" :timeSlots="timeSlots" :tableSlots="tableSlots" :timeOptions="timeOptions" :response="response"></slot>
  </form>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { email, required, between, helpers } from "@vuelidate/validators";
const isTrue = (value) => {
  return value === true
}
import axios from "axios";

export default {
  props: {
    action: {
      type: String,
      required: true,
      default: ''
    },
    _timeSlots: {
      type: String,
      required: true,
      default: () => []
    },
    _tableSlots: {
      type: String,
      required: true,
      default: () => []
    },
    image: {
      type: String,
      required: false,
      default: null
    }
  },
  data() {
    return {
      v$: useVuelidate(),
      sunsetDisabled: false,
      aftersunsetDisabled: false,
      latenightDisabled: false,
      timeSlots: JSON.parse(this._timeSlots),
      tableSlots: JSON.parse(this._tableSlots),
      response: {
        status: null,
        message: null
      },
      form: {
        sent: false,
        sending: false,
        date: null,
        guests: null,
        timeSlot: null,
        time: null,
        table: null, //null, // Αυτό το έβαλα στις 08/07/2024 γτ κρύψαμε την άλλη επιλογή οπότε ήθελα να ειναι προεπιλεγμένη το outdoor terace
        // tableAgree: false,
        tableFake: false,
        name: null,
        email: null,
        tel: null,
        hotel: null,
        specialOccasion: false,
        specialOccasionType: null,
        specialOccasionBirthdate: null,
        hasVoucher: false,
      },
    }
  },
  computed: {
    timeOptions() {
      let timeOptions;

      try {
        this.form.time = null;

        this.timeSlots.filter((slot) => {
          if (slot.id == this.form.timeSlot) {
            timeOptions = slot.toptions;
          }
        });
      } catch (e) {
        timeOptions = [];
      }

      return timeOptions;
    },
  },
  validations() {
    let validations = null;

    validations = {
      form: {
        date: {
          required
        },
        guests: {
          required,
          between: between(1, 90)
        },
        timeSlot: {
          required
        },
        time: {
          required
        },
        table: {},
        // tableAgree: {},
        tableFake: {},
        name: {
          required
        },
        email: {
          required,
          email
        },
        tel: {
          required,
          phone: helpers.regex(/\(\+\d{1,4}\)\s\d{4,10}/)  // custom validator
        },
        specialOccasion: {
          required
        },
        specialOccasionType: {},
        hasVoucher: {}
      }
    }

    // if (this.form.table === 478) { // palia epilogi to outdoor front row 
    // if (this.form.table === 479) {
    //   validations.form.tableAgree = {
    //     isTrue
    //   }
    // }

    if (this.form.specialOccasion) {
      validations.form.specialOccasionType = {
        required
      }

      if (this.form.specialOccasionType === '461') {
        validations.form.specialOccasionBirthdate = {
          required
        }
      }
    }

    return validations;
  },
  watch: {
    'form.specialOccasion'(newQuestion, oldQuestion) {
      if (!newQuestion) {
        this.v$.form.specialOccasionType.$reset();
        this.form.specialOccasionType = null;
        this.form.specialOccasionBirthdate = null;
      }
    },
    // maimoudia gia table
    'form.tableFake'(newQuestion, oldQuestion) {
      if(newQuestion) {
        this.form.table = 487;
      } else {
        this.form.table = null;
      }
    },
  },
  methods: {
    submit() {
      let self = this;
      self.response.status = null;
      self.response.message = null;
      this.v$.form.$touch();

      if (this.v$.form.$invalid) {
        let invalidField;
        const component = this;
        Object.keys(this.v$.form.$errors).some(function (item) {
          invalidField = Object.keys(component.v$.form).find(key => component.v$.form[key].$invalid);
          // exit on find the first error
          return invalidField;
        });

        self.response.status = 'error';
        self.response.message = "Please check again the form for errors";

        setTimeout(() => {
          self.response.status = null;
          self.response.message = null;
        }, 3000);

        this.$root.$scrollTo(document.querySelector(`[data-scroll="${invalidField}"]`));
      } else {
        this.form.sending = true;

        self.errorstatus = false;
        self.errormessage = null;

        axios
          .get('/en/get/csrf')
          .then(response => {
            var _token = response.data._token;
            axios.defaults.headers.common = {
              'X-Requested-With': 'XMLHttpRequest',
              'X-CSRF-TOKEN': _token
            };
            axios.post(this.action, this.form)
              .then(function (response) {
                self.form.sent = true;
              })
              .catch(function (error) {
                self.form.sent = false;
                self.response.status = 'error';
                self.response.message = error.response.data.message;
              })
              .finally(function () {
                self.form.sending = false;
              });
          })
          .catch(error => {

          });
      }
    },
    resetForm() {
      this.form = {
        sent: false,
        sending: false,
        date: null,
        guests: null,
        timeSlot: null,
        time: null,
        name: null,
        email: null,
        telCode: null,
        tel: null,
        hotel: null,
        specialOccasion: false,
        hasVoucher: false,
        specialOccasionType: null,
      }

      this.v$.$reset()
    },
    dateChecker() {
      var asDate = new moment(new Date(this.form.date));

      let _url = '/en/check/available/dates';
      let self = this;

      axios
        .get('/en/get/csrf')
        .then(response => {
          var _token = response.data._token;
          axios.defaults.headers.common = {
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': _token
          };

          axios.post(_url, {
            'date': asDate.format('YYYY-MM-DD')
          })
            .then(function (response) {
              var data = response.data;
              self.form.timeSlot = null;

              self.sunsetDisabled = false
              self.aftersunsetDisabled = false
              self.latenightDisabled = false

              if (data.status) {
                self.sunsetDisabled = false
                self.aftersunsetDisabled = false
                self.latenightDisabled = false
              } else {

                if (data.disable != '') {
                  // 'SUNSET BOOKED',    // 11
                  // 'AFTER BOOKED',     // 12
                  // 'LATE BOOKED',      // 13
                  // var disableName = data.disable.replace(' ', '').toLowerCase();
                  data.disable.forEach(function (obj, idx) {
                    var value = obj.replace(' BOOKED', '').toLowerCase();
                    if (value == 'sunset') {
                      self.sunsetDisabled = true;
                    } else if (value == 'after') {
                      self.aftersunsetDisabled = true;
                    } else if (value == 'late') {
                      self.latenightDisabled = true;
                    }
                  })

                } else {
                  self.sunsetDisabled = true
                  self.aftersunsetDisabled = true
                  self.latenightDisabled = true
                }
              }
            })
            .catch(function (error) {
              this.response.status = 'error';
              this.response.message = 'Error on availability check for this day';
            });
        })
        .catch(error => {

        });
    },
  },
  // updated() {
  //   console.log('update')
  // }
}

</script>

<style></style>